/* eslint-disable prefer-spread */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
import { HttpUtils } from 'src/app/utils/httpUtils';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppTypeEnum } from 'src/app/model/appType';
import { ProtocolReportFilter } from 'src/app/model/attachment';
import { PendingSignStatusEnum } from 'src/app/model/pendingSignStatus';
import { PendingSignType, PendingSignTypeEnum } from 'src/app/model/pendingSignType';
import { ProtocolAir } from 'src/app/model/protocol';
import { SignInfo } from 'src/app/model/sign';
import { User } from 'src/app/model/user';
import { PendingSignTypeService } from 'src/app/services/pendingSignType.service';
import { ProtocolAirService } from 'src/app/services/protocolAir.service';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { LangFlag, TranslationService } from 'src/app/services/translation.service';
import { UserService } from 'src/app/services/user.service';
import { UsersService } from 'src/app/services/users.service';
import { ArrayUtils } from 'src/app/utils/arrayUtils';
import { DateUtils } from 'src/app/utils/dateUtils';
import { ProtocolUtils } from 'src/app/utils/protocolUtils';
import { ActionConfirmPasswordComponent } from '../../shared/action-confirm-password/action-confirm-password.component';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { ReasonDialogComponent } from '../../shared/reason-dialog/reason-dialog.component';
import { ManageUsersService } from 'src/app/services/manageUsers.service';
import { GroupEnum } from '../../../utils/groupUtils';
import { StringUtils } from '../../../utils/stringUtils';

export interface DialogDataAutomaticSignProtocol {
  protocol: ProtocolAir;
}

@Component({
    selector: 'app-protocol-edit-dialog-automatic-sign',
    templateUrl: './protocol-edit-dialog-automatic-sign.component.html',
    standalone: false,
})
export class ProtocolEditDialogAutomaticSignComponent implements OnInit, OnDestroy {

  respDocs: User[];
  respDocsFiltered: User[];

  reportConfig: ProtocolReportFilter;
  langs: LangFlag[];

  signTypes: PendingSignType[];
  signTypeChecked = new Map<number, boolean>();
  disableSignType = false;

  showLang = false;
  nextSign: string;

  currentUser: User;

  canRefuse = false;

  selectedGroup: number;

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ProtocolEditDialogAutomaticSignComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAutomaticSignProtocol,
    private protocolService: ProtocolAirService,
    private userService: UserService,
    private usersService: UsersService,
    private manageUsersService: ManageUsersService,
    private pendingSignType: PendingSignTypeService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) {
    this.currentUser = this.userService.currentProfile;
  }

  ngOnInit(): void {
    this.spinnerService.show();

    const currentProfile = this.userService.currentProfile;

    this.selectedGroup = currentProfile.profiles.find(p => p.idGroup === currentProfile.idActiveProfile)?.idGroup;

    this.langs = this.translationService.configuredLangs;

    this.reportConfig = new ProtocolReportFilter();
    this.reportConfig.lang = this.data.protocol.lang;

    this.signTypes = [];
    this.pendingSignType.findAll().pipe(takeUntil(this.destroy$)).subscribe((r: PendingSignType[]) => this.signTypes = r);

    this.protocolService.signInfo(this.data.protocol).pipe(takeUntil(this.destroy$)).subscribe((inf: SignInfo[]) => {

      inf.forEach(i => {
        i.date = DateUtils.anyToDate(i.date);
      });

      const anySign = !ArrayUtils.isEmpty(inf);
      let usersToRemove = [];

      this.signTypeChecked.set(PendingSignTypeEnum.REVIEW, true);
      this.signTypeChecked.set(PendingSignTypeEnum.APPROVED, false);

      if (!anySign) {
        this.showLang = true;
      } else {
        const anyApprove = anySign && inf.map(i => i.idType).includes(PendingSignTypeEnum.APPROVED);

        if (anyApprove) {
          this.disableSignType = true;
          this.signTypeChecked.set(PendingSignTypeEnum.REVIEW, false);
          this.signTypeChecked.set(PendingSignTypeEnum.APPROVED, true);
        }

        usersToRemove = inf.map(i => i.username);

        const lastDate = Math.max.apply(Math, inf.filter(s => s.idStatus === PendingSignStatusEnum.PENDING).map(s => s.date));
        const lastSign = inf.filter(s => s.idStatus === PendingSignStatusEnum.PENDING).find(i => i.date.getTime() === lastDate);
        const isLastSign = lastSign != null && (lastSign.username === this.currentUser.username);

        if (anySign && usersToRemove.includes(this.currentUser.username) && !isLastSign) {
          this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.alreadySign') as string);
          this.onNoClick();
          this.spinnerService.hide();
          return;
        }

        if (anySign && !isLastSign) {
          this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.notLastSign') as string);
          this.onNoClick();
          this.spinnerService.hide();
          return;
        }

        this.canRefuse = isLastSign;
      }

      this.usersService.findAllUserToSignFromGroup().pipe(takeUntil(this.destroy$)).subscribe((item: User[]) => {
        const sorted = item.filter(u => !usersToRemove.includes(u.username) && u.username !== this.currentUser.username)
          .sort((v1, v2) => v1.fullName.localeCompare(v2.fullName));
        this.respDocs = sorted;
        this.respDocsFiltered = sorted.filter(u => u.fullName !== this.currentUser.fullName);

        this.spinnerService.hide();
      });

    }, () => {
      this.spinnerService.hide();
      this.onNoClick();
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNextSignChange(event: MatSelectChange): void {
    this.nextSign = event.value as string;
  }

  isSignTypeChecked(item: PendingSignType): boolean {
    return this.signTypeChecked.get(item.id) || false;
  }

  onChangeSignTypeCheck(event: MatCheckboxChange): void {
    const signType = event.source.value as unknown as PendingSignType;

    this.signTypeChecked.set(signType.id, event.checked);
  }

  getOkLabel(): string {
    let label = 'button.sign';

    if (this.nextSign != null) {
      label = 'button.sendSign';
    }

    return this.translate.instant(label) as string;
  }

  onOkClick(): void {
    this.spinnerService.show();

    const errors = [];

    const checks: number[] = [];

    this.signTypeChecked.forEach((value, key) => {
      if (value) {
        checks.push(key);
      }
    });

    if (ArrayUtils.isEmpty(checks)) {
      errors.push(this.translate.instant('protocolEdit.dialog.generateReport.form.error.anySignReason'));
    }


    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));
      return;
    }

    const protocol = this.data.protocol;
    this.spinnerService.hide();

    if (this.nextSign == null) {
      const message = this.translate.instant('protocolEdit.dialog.generateReport.form.isLastSign') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response === true) {
          if (protocol.idClient) {
            this.manageUsersService.checkIfHasUser(protocol.idClient).subscribe(hasUser => {
              if(!hasUser && this.selectedGroup === GroupEnum.QUALIPHARMA){
                this.snackBarService.sendError(this.translate.instant('manageUsers.dialog.clientHasUsers.error') as string);
              } else {
                this.requestSign((token) => {
                  if (StringUtils.isNotEmpty(token)) {
                    this.spinnerService.show();
                  
                    this.protocolService.automaticSign(protocol, token, checks, this.reportConfig.lang).pipe(takeUntil(this.destroy$))
                      .subscribe(() => {
                        this.spinnerService.hide();
                        this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.form.sign.ok') as string);

                        this.protocolService.downloadPdfVersion(protocol.id, protocol.currentVersion).pipe(takeUntil(this.destroy$))
                          .subscribe((file: Blob) => {
                            const name = ProtocolUtils.getNameForProtocolAir(protocol, this.translate);
                            saveAs(file, name);
                            this.dialogRef.close(this.data);
                          });
                      }, err => {
                        if (HttpUtils.hasErrorMessage(err)) {
                          this.snackBarService.sendError(err.error as string);
                        } else {
                          this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.generic') as string);
                        }
                        this.spinnerService.hide();
                      });
                    }
                });
              }
            });
          } else {
            this.requestSign((token) => {
              if (StringUtils.isNotEmpty(token)) {
                this.spinnerService.show();
                this.protocolService.automaticSign(protocol, token, checks, this.reportConfig.lang).pipe(takeUntil(this.destroy$))
                  .subscribe(() => {
                    this.spinnerService.hide();
                    this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.form.sign.ok') as string);

                    this.protocolService.downloadPdfVersion(protocol.id, protocol.currentVersion).pipe(takeUntil(this.destroy$))
                      .subscribe((file: Blob) => {
                        const name = ProtocolUtils.getNameForProtocolAir(protocol, this.translate);
                        saveAs(file, name);
                        this.dialogRef.close(this.data);
                      });
                  }, err => {
                    if (HttpUtils.hasErrorMessage(err)) {
                      this.snackBarService.sendError(err.error as string);
                    } else {
                      this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.generic') as string);
                    }
                    this.spinnerService.hide();
                  });
                }
            });
          }
        } else {
          this.spinnerService.hide();
        }
      });

    } else {
      this.requestSign((token) => {
        this.protocolService.addSign(protocol, token, checks, this.nextSign, this.reportConfig.lang).pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.dialog.generateReport.form.addSign.ok') as string);

            this.spinnerService.hide();

            this.dialogRef.close(this.data);
          }, () => {
            this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.addSign.error') as string);
            this.spinnerService.hide();
          });
      });
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  refuseSign(): void {
    this.requestReason((reason) => {
      this.requestSign((result) => {
        if (StringUtils.isNotEmpty(result)) {
          this.protocolService.refuseToSign(this.data.protocol, result, reason).pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.dialog.generateReport.form.reject.ok') as string);

            this.spinnerService.hide();

            this.dialogRef.close(this.data);
          }, () => {
            this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.reject.error') as string);
            this.spinnerService.hide();
          });
        }
      });
    });

  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  showThermal(): boolean {
    const currentUser = this.userService.currentProfile;

    if (currentUser == null) {
      return false;
    }

    return currentUser.idActiveApp === AppTypeEnum.THERMAL;
  }

  private requestSign(callback: (token: string) => void) {
    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {
        title: 'protocolAuditAction.refuseSign'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

}
